import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  gridContainer: {
    height: '100%',
  },
  gridContainerWrapper: {
    '&.MuiGrid-item': {
      paddingBottom: '0',
    },
  },
  resultsContainer: {
    flexFlow: 'column wrap',
    fontFamily: Theme.typography.base.regular,
    padding: '20px 16px 48px',

    [Theme.breakpoints.only('md')]: {
      padding: '20px 40px 25px',
    },
    [Theme.breakpoints.up('lg')]: {
      margin: '0 auto',
      maxWidth: '1440px',
      padding: '30px 24px 24px',
    },
    '& .change-flight-container': {
      marginBottom: '16px',
    },

    '& .cardFlightInfoBox': {
      paddingTop: 0,
    },
  },
  containerFormSearchFlight: {
    '& .MuiFormLabel-root': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[1],
      color: Theme.palette.gray[750],
    },
    '& ul > li, .MuiInputBase-input': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
    },

    marginLeft: '24px',
    [Theme.breakpoints.between('xs', 'md')]: {
      marginLeft: '0px',
    },
  },
  searchWrapper: {
    overflow: 'unset',
    flexDirection: 'column',
    minHeight: '194px',
    marginBottom: '21px',
    background: '#FFF',
    borderRadius: '0',
    position: 'relative',
    display: 'flex',
    boxShadow: '0px 2px 4px 0 rgb(6 21 86 / 15%) !important',
    [Theme.breakpoints.down('lg')]: {
      minHeight: '184px',
      marginBottom: '20px',
    },
    [Theme.breakpoints.down('md')]: {
      marginBottom: '50px',
      height: 'auto',
    },
    [Theme.breakpoints.down('sm')]: {
      marginBottom: '30px',
    },
  },
  searchWrapperCardContent: {
    height: '100%',
    padding: '0',
    display: 'flex',
    flexGrow: '1',
    '&:last-child': {
      paddingBottom: '0',
    },
  },
  mobileClearFilterButton: {
    width: 175,
    marginTop: 30,

    [Theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  centered: {
    textAlign: 'center',
  },
  mobileNoResults: {
    [Theme.breakpoints.down('sm')]: {
      height: 'auto !important',
    },
  },
  resultsWrapper: {
    display: 'inline-flex',
    padding: '0',
    margin: '0',
    width: '100%',
    height: 'calc(100% - 215px)',
    [Theme.breakpoints.down('md')]: {
      height: 'calc(100% - 400px)',
    },
    [Theme.breakpoints.down('sm')]: {
      height: 'calc(100% - 510px)',
    },
  },

  filterPanelHeader: {
    zIndex: '9999',
    backgroundColor: Theme.palette.primary.main,

    '& .MuiTypography-root > p': {
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[1],
    },

    '&.cel': {
      backgroundColor: Theme.palette.white,
      color: Theme.palette.primary.main,
    },
  },

  filterSection: {
    padding: 24,
    height: 'calc(100% + 32px)',
    background: '#FFF',
    borderBottomRightRadius: '0',
    [Theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  resultsFooter: {
    padding: '23px 20px',
    [Theme.breakpoints.up('md')]: {
      padding: '23px 50px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '23px 70px 23px 60px',
    },
  },
  resultsFooterInfo: {
    color: Theme.palette.gray[750],
  },
  filtersPanelDrawer: {
    fontFamily: Theme.typography.base.regular,
    boxShadow: 'none',
    height: 'calc(100% - 60px)',
    paddingTop: '60px',
    boxSizing: 'border-box',
    top: '60px',
    [Theme.breakpoints.up('xs')]: {
      padding: '30px 20px',
      width: '100%',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '30px 40px 30px 50px',
      width: '380px',
    },
  },
  searchFlightsPageForm: {
    '& .inlineMenu': {
      '& > div': {
        [Theme.breakpoints.down('lg')]: {
          paddingLeft: '10px !important',
        },
        [Theme.breakpoints.down('sm')]: {
          paddingLeft: '20px !important',
        },
        '& button': {
          color: Theme.palette.primary.light,
          fontSize: Theme.typography.size[1],
          fontFamily: Theme.typography.base.regular,
          [Theme.breakpoints.down('sm')]: {
            fontSize: Theme.typography.size[2],
          },
        },
      },
    },
    '& .gridButtonMobileWrapper': {
      [Theme.breakpoints.down('sm')]: {
        paddingRight: '20px',
        paddingLeft: '20px',
      },
    },
  },

  newDepartingSection: {
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    [Theme.breakpoints.up('md')]: {
      marginBottom: '30px',
    },
    '& .title': {
      fontSize: Theme.typography.size[6],
      color: Theme.palette.primary.main,
      fontFamily: Theme.typography.base.semiBold,
      letterSpacing: '0.8px',
      marginRight: '8px',
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[9],
      },
    },
    '& .title.changeFlight': {
      fontSize: Theme.typography.size[4],
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[6],
      },
    },
    '& > span svg': {
      color: Theme.palette.primary.light,
      width: '16px',
      height: '16px',
      marginTop: '4px',
    },
  },

  '.MuiTooltip-popper .MuiTooltip-tooltip .MuiButtonBase-root': {
    top: '12px',
    right: '12px',
  },

  customBanner: {
    marginBottom: 24,
  },
  progressLineContainer: {
    width: '100vw',
  },
}));

export default useStyles;
